import { h, Component } from 'preact'
import axios, { AxiosError, AxiosResponse } from 'axios'

import Header from '../../control-components/header/index'
import Panel from '../../control-components/panel/index'
import InputGroup from '../../control-components/ui-components/InputGroup'
import ButtonControl from '../button-control'
import Credentials from './Credentials'
import AlertComponent from '../../control-components/ui-components/AlertComponent'
import List from './List'
import { ExternalLink } from '../../control-components/ui-components/ExternalLink'

interface CustomerClient {
  id: string,
  name: string,
  clientId: string,
  createdAt: string,
  secret: string
}

type Props = Readonly<{
  url: string,
  clients: Array<CustomerClient>
}>

interface State {
  name: string,
    processing: boolean,
    clients: Array<CustomerClient>,
    credentials?: { id: string, secret: string },
    error?: string
}

class Form extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = { name: '', processing: false, error: undefined, clients: props.clients }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.successResponse = this.successResponse.bind(this)
    this.errorResponse = this.errorResponse.bind(this)
  }

  handleChange (evt: ChangeEvent) {
    let { value } = evt.target

    if (!value) {
      return
    }

    this.setState({ name: value })
  }

  handleSubmit (evt: Event) {
    evt.preventDefault()

    let { processing, name } = this.state
    if (processing) {
      return
    }

    this.setState({ processing: true, error: undefined })

    axios.post('/settings/api/clients', { name: name }).then(this.successResponse).catch(this.errorResponse)
  }

  handleRevoke (client: CustomerClient) {
    this.setState({ error: undefined })
    let self = this

    axios.post('/settings/api/revoke', { client_id: client.id }).then(() => {
      self.setState({ clients: self.state.clients.filter((curr) => curr !== client) })
    }).catch(this.errorResponse)
  }

  successResponse (response: AxiosResponse<CustomerClient>) {
    if (!response.data) {
      return
    }

    let client = response.data
    let clients = this.state.clients
    clients.push(client)

    this.setState({ processing: false, credentials: { id: client.clientId, secret: client.secret }, clients: clients })
  }

  errorResponse (error: AxiosError<{message: string}>) {
    let message = 'Something went wrong'
    let response = error.response

    if (response && response.data.message) {
      message = response.data.message
    }

    this.setState({ processing: false, error: message })
  }

  render ({ url }: Props, { name, processing, error, credentials, clients }: State) {
    return (
      <section className='oauth2-create-client'>
        <Header title='API' disableCancelButton disableSaveButton />
        <AlertComponent messageType={error ? 'error' : null} message={error} />
        <form onSubmit={this.handleSubmit}>
          <Panel title='OAuth2'>
            <InputGroup title='Label *' meta='Use a label as a reminder of why you generated this client.' required placeholder='Enter an application name' disabled={processing || !!credentials} onChange={this.handleChange} value={name} />
            {!credentials && <ButtonControl variant='brand' newStyle type='submit' title='Create an OAuth2 client' isLoading={processing} />}
            {credentials && <Credentials credentials={credentials} />}
          </Panel>
        </form>
        <List clients={clients} onRevokeButtonClick={(e: CustomerClient) => this.handleRevoke(e)} />
        <ExternalLink label='API Documentation' url={url} />
      </section>
    )
  }
}

export default Form
